/*
 * @Description: 
 * @Author: xgx
 * @Date: 2022-10-08 16:09:47
 * @LastEditors: xgx
 * @LastEditTime: 2022-10-18 17:23:53
 */
import req from "@/utils/request";
export const create = (params) => req.post("/site-service/m/site/create", params);
export const list = (params) => req.post("/site-service//m/site/list", params);
export const tree = (params) => req.post("/site-service/m/site/tree", params);
export const update = (params) => req.post("/site-service/m/site/update", params);
export const down = (params) => req.post("/site-service/m/site/sort-down", params);
export const up = (params) => req.post("/site-service/m/site/sort-up", params);
export const deleteSite = (params) => req.post("/site-service/m/site/delete", params);
